import { useState, useEffect } from 'react';

interface ScreenSize {
  width: number;
  height: number;
  isMinimumSize: boolean;
}

const MINIMUM_WIDTH = 1000;
const MINIMUM_HEIGHT = 600;

/**
 * Custom Hook to monitor screen size and determine if it meets minimum requirements
 */
export const useScreenSize = (): ScreenSize => {
  const [screenSize, setScreenSize] = useState<ScreenSize>(() => {
    const width = window.innerWidth;
    const height = window.innerHeight;
    return {
      width,
      height,
      isMinimumSize: width >= MINIMUM_WIDTH && height >= MINIMUM_HEIGHT,
    };
  });

  useEffect(() => {
    const handleResize = () => {
      const width = window.innerWidth;
      const height = window.innerHeight;
      
      setScreenSize({
        width,
        height,
        isMinimumSize: width >= MINIMUM_WIDTH && height >= MINIMUM_HEIGHT,
      });
    };

    // Add event listener
    window.addEventListener('resize', handleResize);
    
    // Call handler right away so state gets updated with initial window size
    handleResize();

    // Remove event listener on cleanup
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return screenSize;
};

export default useScreenSize;
